import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { useLanguage } from "../../Context/LanguageContext";
import { useTheme } from "../../Context/ThemeContext";
import { lightTheme, darkTheme } from "../../Styles/theme";

import { ReactComponent as LeftArrowIcon } from '../../image/LeftArrow.svg';

export default function MainPageWorkoutSelectBox(props) {
  const { options, value, setValue } = props;
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [isClicked, setIsClicked] = useState(false);
  const [enabled, setEnabled] = useState(false);

  const TotalRef = useRef();
  const SelectListRef = useRef();

  // 이미 저장된 수업은 먼저 세팅해주기 //
  useEffect(() => {
    if (options.length === 0) {
      setEnabled(false);
      return;
    }
    
    if (options.length === 1) setEnabled(false);
    else setEnabled(true);

    setValue(options[0]);
  }, [options])

  // 컴포넌트 밖을 클릭하면 셀렉트 창 닫기 //
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [onClickOutSide])

  // 컴포넌트 밖을 클릭하면 셀렉트 창 닫기 //
  function onClickOutSide(e) {
    if (TotalRef.current !== e.target && !TotalRef.current.contains(e.target) && enabled) {
      SelectListRef.current.style.height = `0px`;
      SelectListRef.current.style.border = '0px';
      SelectListRef.current.style.overflow = 'hidden';
      setIsClicked(false);
    }
  }

  // 셀렉트 박스 색상 결정 //
  function decideSelectBoxBackgroundColor() {
    if (value === undefined) return theme.subBackground;
    else return value.color;
  }

  // 셀렉트 박스 텍스트 결정 //
  function decideValueText() {
    if (value === undefined) return '';
    else return (value.title + ' (' + value.lessonName + ')');
  }

  // 셀렉트 박스 클릭시 //
  function onClickSelectBox() {
    if (!enabled) return;

    if (isClicked) {
      SelectListRef.current.style.height = `0px`;
      SelectListRef.current.style.border = '0px';
      SelectListRef.current.style.overflow = 'hidden';
      setIsClicked(false);
    }
    else {
      SelectListRef.current.style.height = `auto`;
      SelectListRef.current.style.overflow = `visible`;
      const scrollH = SelectListRef.current.scrollHeight;
      SelectListRef.current.style.transition = `none`;
      SelectListRef.current.style.height = `0px`;
      SelectListRef.current.style.overflow = `hidden`;
      void SelectListRef.current.offsetHeight;
      SelectListRef.current.style.transition = ``;
      SelectListRef.current.style.backgroundColor = theme.subBackground;
      SelectListRef.current.style.border = `1px solid ${theme.primary}`;
      SelectListRef.current.style.height = scrollH > 500 ? `500px` : `${scrollH}px`;
      SelectListRef.current.style.maxHeight = `500px`;
      SelectListRef.current.style.overflowY = `scroll`;
      SelectListRef.current.style.overflowX = `none`;
      setIsClicked(true);
    }
  }

  // 수업 선택시 //
  function onClickSelectList(data) {
    setValue(data);

    SelectListRef.current.style.height = `0px`;
    SelectListRef.current.style.border = '0px';
    SelectListRef.current.style.overflow = 'hidden';
    setIsClicked(false);
  }

  return (
    <SelectBoxWrapper ref={TotalRef}>
      {
        options.length === 0 ?
          <NoneSelectBox>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} hover='pointer'>{t('main.board.noProgram')}</Text>
          </NoneSelectBox>
          :
          <SelectBoxInnerWrapper>
            <SeletedBox
              $enabled={enabled}
              onClick={onClickSelectBox}>
              <SelectBoxTag backgroundColor={decideSelectBoxBackgroundColor()} />
              <SelectBoxTextWrapper $enabled={enabled}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover={enabled ? 'pointer' : 'default'}>{decideValueText()}</Text>
              </SelectBoxTextWrapper>
              {enabled && <ArrowIcon $isClicked={isClicked} />}
            </SeletedBox>
            <WillSelectList ref={SelectListRef}>
              {
                options.map((data, index) => (
                  <SelectListTextWrapper
                    key={'SelectLesson-' + index}
                    onClick={() => onClickSelectList(data)}
                    hoverBackgroundColor={data.color}>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='pointer'>{(data.title + ' (' + data.lessonName + ')')}</Text>
                  </SelectListTextWrapper>
                ))
              }
            </WillSelectList>
          </SelectBoxInnerWrapper>
      }
    </SelectBoxWrapper>
  )
}

const SelectBoxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 100%;

  transition: all 0.3s ease-in-out;
`;

const SelectBoxInnerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 100%;

  transition: all 0.3s ease-in-out;
`;

const NoneSelectBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0px 10px;

  width: calc(100% - 24px);
  height: calc(100% - 4px);

  border: 2px solid ${props => props.theme.line};
  border-radius: 5px;
  background-color: ${props => props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const SeletedBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  position: relative;

  padding: 0px 10px 0 20px;

  width: 100%;
  height: 100%;

  border-radius: 5px;
  border: 1px solid ${props => props.theme.buttonStroke};
  background-color: ${props => props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.$enabled ? 'pointer' : 'default'};
    }
  }

  transition: all 0.3s ease-in-out;
`;

const SelectBoxTag = styled.div`
  position: absolute;
  left: -1px;
  top: -1px;
  bottom: -1px;

  width: 16px;

  border-radius: 5px 0 0 5px;
  background-color: ${props => props.backgroundColor};
`;

const ArrowIcon = styled(LeftArrowIcon)`
  width: 9px;
  height: 15px;

  flex-shrink: 0;

  transform: ${props => props.$isClicked ? `rotate(-270deg)` : `rotate(-90deg)`};

  & path {
    fill: ${props => props.theme.line};
    transition: stroke 0.3s ease-in-out;
  }

  transition: all 0.3s ease-in-out;
`;

const WillSelectList = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 42px;

  width: calc(100% + 30px);
  height: 0px;

  border-radius: 6px;

	overflow: hidden;

	@media (hover: hover) {
		&:hover {
			cursor: pointer;
		}
	}

	&::-webkit-scrollbar {
		width: 0px;
	}

	&::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px ${props => props.theme.primary};
		border: 3px solid transparent;
		height: 25px;
		border-radius: 200px;
	}

	&::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
		border: 4px solid transparent;
		background-color: transparent;
	}

	&::-webkit-scrollbar-track-piece {
		background-color: transparent;
	}

  transition: all 0.3s ease-in-out;
`;

const SelectBoxTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.$enabled ? '87%' : '100%'};
  height: 21px;

  overflow: hidden;

  & p {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const SelectListTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  padding: 5px 10px;

  width: calc(100% - 20px);
  min-height: 16px;

  overflow: hidden;
  
  background-color: ${props => props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.hoverBackgroundColor};
    }
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  
  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.hover};
    }
  }

  transition: all 0.3s ease-in-out;
`;